//saque el string aparte xq omit te permite mandar fruta
const provinciaStr: keyof Pick<ICompra["datosEnvio"], "provincia"> =
  "provincia";

type CommonFeaturesInputs = {
  required: boolean;
  errorMsg?: string;
  innerText: string;
};

export type RegularInputs = {
  id: keyof Omit<ICompra["datosEnvio"], typeof provinciaStr>;
  type: "text" | "number";

  placeholder: string;
  select: false;
} & CommonFeaturesInputs;

export type SelectInput = {
  id: typeof provinciaStr;
  select: true;
} & CommonFeaturesInputs;

export const rest: readonly (RegularInputs | SelectInput)[] = [
  {
    id: "depto",
    type: "text",
    placeholder: "Piso/depto (opcional)",
    innerText: "Piso/Depto",
    required: false,
    select: false,
  },
  {
    id: "ciudad",
    type: "text",
    placeholder: "Ciudad*",
    innerText: "Ciudad",
    required: true,
    errorMsg: "Indicar ciudad",
    select: false,
  },
  {
    //SELECT no lleva placeholder ni type
    id: "provincia",
    innerText: "Provincia",
    select: true,
    required: true,
    errorMsg: "Seleccionar provincia",
  },
  {
    id: "CP",
    type: "text",
    placeholder: "Código postal*",
    innerText: "Código postal",
    required: true,
    errorMsg: "Indicar código postal",
    select: false,
  },
] as const;

const row1: readonly RegularInputs[] = [
  {
    id: "nombreDestinatario",
    type: "text",
    placeholder: "Nombre*",
    innerText: "Nombre de quien recibe",
    errorMsg: "Indicar nombre. Máximo 25 caracteres.",
    required: true,
    select: false,
  },
  {
    id: "apellidoDestinatario",
    type: "text",
    placeholder: "Apellido*",
    innerText: "Apellido de quien recibe",
    errorMsg: "Indicar apellido. Máximo 25 caracteres.",
    required: true,
    select: false,
  },
] as const;

export const NOMBRE_DEST = row1[0].id;

export const APELLIDO_DEST = row1[1].id;

const row2: readonly RegularInputs[] = [
  {
    id: "calle",
    type: "text",
    placeholder: "Calle/Avenida*",
    innerText: "Calle para el envío",
    required: true,
    errorMsg: "Indicar calle",
    select: false,
  },
  {
    id: "nro",
    type: "number",
    placeholder: "Número/altura*",
    innerText: "Número/altura",
    required: true,
    errorMsg: "Indicar altura",
    select: false,
  },
] as const;

export const rows = [row1, row2] as const;

export const fullData = [...row1, ...row2, ...rest] as const;
